import {AjaxP, Module} from '@mamdev/cad.static-next-lib';
import Viewport from '../../ts/services/viewport';
import Tracking2 from '../../ts/services/tracking2';

import type {TeaserData} from './ITeaserData';

export default class Header extends Module {
  private readonly leftColFirst5: number[];
  private readonly navOpenClass: string;

  private navTrigger: HTMLElement | null;
  private leftCol: HTMLElement | null;

  /** Init. from DOM. */
  static attachTo(root: HTMLElement): Header {
    return new Header(root);
  }

  constructor(root: HTMLElement) {
    super(root);

    this.name_ = 'header';
    this.navOpenClass = 'nav-open';
    this.leftColFirst5 = [];
  }

  /** Start the module. */
  start() {
    this.navTrigger = this.root_.querySelector('.new-header__navtrigger');

    if (this.navTrigger) {
      this.navTrigger.addEventListener('click', () => {
        Tracking2.callTealiumLink({
          businessEventType: 'userAction',
          componentPath: 'header.1.navigation1.burger',
          componentResultState: 'open',
          componentName: 'burger-menu-icon',
          elementTagName: 'label',
          eventType: 'mousedown',
          targetUrl: window.ui?.pageinfo?.home
        });

        this.openNavigation();
      });
    }

    this.leftCol = document.querySelector('.left-col');

    if (this.leftCol) {
      const teaserUrl = this.leftCol.dataset.teasers;
      if (teaserUrl) {
        const newTeaserUrl = this.addExcludeIdsParam(teaserUrl);
        const teaserListContainer = this.leftCol.getElementsByClassName('teasers')[0];
        this.showLeftColumnTeasers(newTeaserUrl, teaserListContainer);
      }
    }

    this.subscribe('newnav:closeNavLayer', () => {
      this.closeNavigation();
    });

    const trackedElement = this.root_.querySelectorAll('[data-component-path]');
    Tracking2.bindTrackingClickHandler(trackedElement);
  }

  /** [CADNPCA-8852] Contruct a query string parameter of corem-ids that are already rendered */
  addExcludeIdsParam(url: string): string {
    let dupParam = '';
    const uiDups = window.ui.duplication;
    if (uiDups?.usedContentIds) {
      dupParam = `${(url.indexOf('?') > 0) ? '&' : '?'}excludeIds=${uiDups.usedContentIds.join(',')}`;
    }
    return url + dupParam;
  }

  showLeftColumnTeasers(url: string, container: Element) {
    if (!url || !container) {
      this.log('Not url or container');
      return;
    }

    if (!Viewport.matches('tablet')) return;

    let teaserHtml = '';

    AjaxP.getJSON(url, {}).then(data => {
      this.log('Received leftcol teasers');

      const teaserData = data as TeaserData;
      const teasers = teaserData.teasers.top;

      for (const t of teasers) {
        teaserHtml += t.teaser;

        if (this.leftColFirst5.length <= 4) {
          const teaserId = parseInt(t.teaserId) || 0;
          if (teaserId > 0) {
            this.leftColFirst5.push(teaserId);
          } else {
            this.publish('sentry:log', {error: 'TeaserId is not a number. URL: ' + url, module: 'header'});
          }
        }
      }

      container.innerHTML = teaserHtml;

      this.publish('general:newContent', container);
      // init dyn teaser module
      this.publish('mod:dynInit', container);
    }).catch(e => {
      this.logUnknownError(e, true);
    }).finally(() => {
      this.leftColumnReady();
    });
  }

  /** Inform that the left column is ready */
  leftColumnReady() {
    try {
      this.subscribeOnce('infinitescroll:pingInfScroll', () => {
        this.publish('newheader:leftColReady', this.leftColFirst5.join(','));
      });

      this.publish('newheader:leftColReady', this.leftColFirst5.join(','));
    } catch (e) {
      this.logUnknownError(e, true);
    }
  }

  openNavigation() {
    if (!document.body.classList.contains(this.navOpenClass)) {
      // nav closed, open it
      this.publish('nav:opening');
      this.navTrigger?.tagName.toLowerCase();
    }
  }

  closeNavigation() {
    if (document.body.classList.contains(this.navOpenClass)) {
      document.body.classList.remove(this.navOpenClass);
      document.documentElement.classList.remove(this.navOpenClass);
    }
  }
}
